import React from 'react';
import { Card, Box, H3, T } from '@veracity/vui';

const ChecklistHeader = ({ name, tag, dateCreated, dateClosed }) => (
  <Card p={4} mb={6}>
    <Box justifyContent="space-between" flexDirection="column" alignItems="flex-start">
      <Box flexDirection="column" alignItems="flex-start">
        <H3 fontWeight="demi">{name}</H3>
        <T color="seaBlue.28" size="sm">{tag}</T>
      </Box>
      <Box flexDirection="column" alignItems="flex-start" >
        <T fontSize="sm">created: {new Date(dateCreated).toLocaleDateString('en-GB')}</T>
          {dateClosed && (
            <T fontSize="sm">closed: {new Date(dateClosed).toLocaleDateString('en-GB')}</T>
          )}
      </Box>
    </Box>
  </Card>
);

export default ChecklistHeader;